const actions = {
  POST_INVITE_FRIEND_DATA: "postInviteFriendData"
};

export default actions;
